export const environment = {
    production: true,
    API_URL: '/api',
    APP_CLIENT_ID: 'd7ea5d7d-6e90-47f3-bab6-fa3a22c2fa71',
    APP_TENANT_ID: '0002cd24-7dd6-4542-acd6-e0c7e184c80c',
    APP_SCOPES: ['api://c120a8f1-7395-440a-8191-acaeff583431/user_impersonation'],
    BACKEND_BASE_URL: 'https://msr-internal-api.prod.caas.everestre.net',
    MANUAL_PAYMENT_UPDATE_ALLOWED_DATE: '7/28/2025',
    IDLE_TIMEOUT_MINUTES: 60,

    //PowerBi Report IDs
    MSR_EXCEPTION_REPORT_PAST_DUE_CASH_AND_NO_REPORTING_FORMS: '8605c1c5-a094-4fbb-b201-ef6ca3c0865f',
    MSR_EXCEPTION_REPORT_INSUFFICIENT_CASH_BALANCE: 'aaf6e2d4-eda6-4276-aa98-f0d3fe429bd1',
    MSR_NEW_POLICY_REPORT: '93239b72-cb16-4681-aa62-f819c54f74d2',
    PROCESSED_MSR_TOTALS: 'aa980c74-3865-42cd-86a1-1547beb9e5ad',
    MSR_EXCEPTION_REPORT_CASH_RECEIVED_NO_REPORTING_FORMS: '1b967c03-545a-47b8-a1e2-25c2b60e5f0a',
    MSR_POLICIES_TO_BE_REINSTATED: '46cc12e6-473e-4067-a284-655b79ed5ffd',
    MSR_CLASS_LEVEL_PREMIUM_DETAIL: '0beb6726-6f05-4c62-bdb3-9012a92818ee',
    MSR_VARIANCE_REPORT: '26410633-54a6-44fc-b7cf-05bc509187b3',
    MSR_CLASS_LEVEL_PREMIUM_SUMMARY: '82c71105-68c7-4d1d-9eb1-9cf1091fc699',

    PRINT_STATEMENT: '4ecb3f90-0389-4057-b227-1879f555d713',
    PRINT_BLANK_FORM: '365ec5a9-a089-4d49-9319-bab8bf560eeb',
    PRINT_SUBMITTED_FORM: '23ed1772-922b-4396-b7cf-88aecb65f406',
    VIEW_INVOICE: '566a7a56-1a2c-4fd9-812d-2f02e9f2b9ca',
    AUDIT_COPY: '79574f78-fe9b-43c7-9ad1-6e38b0c36052',
    ADDITIONAL_PAYMENTS: '2eecfba0-959b-47dc-9571-19d8b6a883de',
    PREVIEW_ENDORSED_REPORTING_FORM: '9770c499-23cd-40ca-87da-e93900c454e2',
    GENERATE_MISSING_REPORTING_FORM: '76fa4037-701f-4382-ae7d-6882ab011247'
};
